import Link from 'next/link';
import { useRouter } from 'next/router';
import useWindowDimensions from './windowsize';
import React, { useState, useEffect } from "react";
import { FaTiktok, FaLinkedinIn, FaTelegramPlane } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { RiHeartsFill, RiHeartsLine, RiFacebookFill, RiInstagramLine, RiYoutubeLine, RiRobot2Line, RiRobot2Fill, RiChatHistoryLine, RiChatHistoryFill, RiUser6Line, RiSearchLine } from 'react-icons/ri';
import { AiFillHome, AiOutlineHome } from 'react-icons/ai';
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { TiArrowBack } from "react-icons/ti";
import { Disclaimer, Avis } from './disclaimer';
import GlobalAudioPlayer from './GlobalAudioPlayer';
import GlobalVideoPlayer from './GlobalVideoPlayer';
import { AppDownloadLinks, AppDownloadBanner } from './appdownload';
import ProfileUser from './member_userProfile';
import { useTheaterMode } from '../context/TheaterModeContext';
import LangButton from './langButton';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Import Tippy.js CSS

function NavTop() {
    const { theaterMode } = useTheaterMode();
    const { width } = useWindowDimensions();
    const router = useRouter();
    const siteVersion = router.pathname.substring(0, 3);
    const [isActive, setActive] = useState(true);

    const ToggleClass = () => {
        if (width > 1200) {
            setActive(isActive);
        } else {
            setActive(!isActive);
        }
    };
    const navtopFR = (<>
        <div className="nav-content">
            <div className="logo">
                <Link href='/fr/accueil'><img src={theaterMode ? "/sunulife-logo-night.png" : "/sunulife-logo-day.png"} alt="Sunulife" /></Link>
            </div>
            <div className="nav-icon" onClick={ToggleClass}>
                <div className="bar one"></div>
                <div className="bar two"></div>
            </div>
            <div className="nav-links">
                <Link href='/fr/histoire' onClick={ToggleClass}>Histoire</Link>
                <Link href='/fr/societe' onClick={ToggleClass}>Soci&eacute;t&eacute;</Link>
                <Link href='/fr/chroniques' onClick={ToggleClass}>Chroniques</Link>
                <Link href='/fr/perspectives' onClick={ToggleClass}>Perspectives</Link>
                <Link href='/fr/opinions' onClick={ToggleClass}>Opinions</Link>
                <Link href='/fr/destinations' onClick={ToggleClass}>Destinations</Link>
                <Link href='/fr/music' onClick={ToggleClass}>Musique</Link>
                <Link href='/fr/moments' onClick={ToggleClass}>Moments</Link>
                <Link href='/fr/videos' onClick={ToggleClass}>Vid&eacute;os</Link>
                <Link href='/fr/tv' onClick={ToggleClass}>TV</Link>
                <Link href='/fr/radio' onClick={ToggleClass}>Radio</Link>
                <Link href='/fr/world-music' onClick={ToggleClass}>Monde</Link>
                <Link href='/en/home' onClick={ToggleClass}>English</Link>
            </div>
            <div className="nav-right">
                <div className="nav-right-ico">
                    <ProfileUser />
                    {/* <Link href='/fr/ia' onClick={ToggleClass}><RiSearchLine  className="search-top-logo" /></Link> */}
                </div>
            </div>
        </div>

    </>);

    const navtopEN = (<>
        <div className="nav-content">
            <div className="logo">
                    <Link href='/en/home'><img src={theaterMode ? "/sunulife-logo-night.png" : "/sunulife-logo-day.png"} alt="Sunulife" /></Link>
            </div>
            <div className="nav-icon" onClick={ToggleClass}>
                <div className="bar one"></div>
                <div className="bar two"></div>
            </div>
            <div className="nav-links">
                <Link href='/en/history' onClick={ToggleClass}>History</Link>
                <Link href='/en/society' onClick={ToggleClass}>Society</Link>
                <Link href='/en/chronicles' onClick={ToggleClass}>Chronicles</Link>
                <Link href='/en/insights' onClick={ToggleClass}>Insights</Link>
                <Link href='/en/opinions' onClick={ToggleClass}>Opinions</Link>
                <Link href='/en/destinations' onClick={ToggleClass}>Destinations</Link>
                <Link href='/en/music' onClick={ToggleClass}>Music</Link>
                <Link href='/en/moments' onClick={ToggleClass}>Moments</Link>
                <Link href='/en/videos' onClick={ToggleClass}>Videos</Link>
                <Link href='/en/tv' onClick={ToggleClass}>TV</Link>
                <Link href='/en/radio' onClick={ToggleClass}>Radio</Link>
                <Link href='/en/world-music' onClick={ToggleClass}>World</Link>
                <Link href='/fr/accueil' onClick={ToggleClass}>Fran&ccedil;ais</Link>
            </div>
            <div className="nav-right">
                <div className="nav-right-ico">
                    <ProfileUser />
                    {/* <Link href='/en/ai' onClick={ToggleClass}><RiSearchLine  className="search-top-logo" /></Link> */}
                </div>
            </div>
        </div>
    </>);

    return (
        <>
            <AppDownloadBanner />
            <div className={isActive ? (theaterMode ? 'nav-dark' : 'nav') : (theaterMode ? 'show-dark' : 'show') }>
                <div className={theaterMode ? 'nav-dark' : 'nav'}>
                    {siteVersion === '/en' ? navtopEN : navtopFR}
                </div>
            </div>
        </>
    );
}

function NavBottom() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0, 3);

    const navbottomFR = (
        <div className="botMenuPadMarg">
            <div className="subNav">
                <Link href='/fr/accueil'>Accueil</Link>
                <Link href='/fr/societe'>Soci&eacute;t&eacute;</Link>
                <Link href='/fr/chroniques'>Chroniques</Link>
                <Link href='/fr/perspectives]'>Perspectives</Link>
                <Link href='/fr/opinions'>Opinions</Link>
                <Link href='/fr/destinations'>Destinations</Link>
                <Link href='/fr/music'>Musique</Link>
                <Link href='/fr/moments'>Moments</Link>
                <Link href='/fr/videos'>Vid&eacute;os</Link>
                <Link href='/fr/tv'>TV</Link>
                <Link href='/fr/radio'>Radio</Link>
                <Link href='/fr/world-music'>Monde</Link>
                <Link href='/en/home'>English</Link>
            </div>
            <br></br>
            <div className="contenu-date">
                <Link href="/fr/raqtaq">&Agrave; propos</Link>&nbsp;/&nbsp;
                <Link href="/fr/icones">Ic&ocirc;nes</Link>&nbsp;/&nbsp;
                <Link href="/fr/publicite">Publicit&eacute;</Link>&nbsp;/&nbsp;
                <Link href="/fr/contact">Contact</Link>&nbsp;/&nbsp;
                <Link href="/fr/publier">Publier</Link>&nbsp;/&nbsp;
                <Link href="/fr/confidentialite">Confidentialit&eacute;</Link>
                <br></br>
                &copy; {new Date().getFullYear()} <Link href="https://seytoo.io" target='_blank'>SEYTOO, tous droits r&eacute;serv&eacute;s.</Link>
                <br></br>
                <Link href="https://seytoo.io" target='_blank'><b>Cr&eacute;&eacute;e avec amour par SEYTOO.</b></Link>

            </div>
            <div className="follow" style={{paddingBottom: `20px`}}>
                <Link href="https://x.com/sunulife_sn" target="_blank" rel="noreferrer"><FaXTwitter /></Link>
                <Link href="https://instagram.com/sunulife.sn" target="_blank" rel="noreferrer"><RiInstagramLine /></Link>
                <Link href="https://facebook.com/sunulife.sn" target="_blank" rel="noreferrer"><RiFacebookFill /></Link>
                <Link href="https://www.youtube.com/@sunulifesn" target="_blank" rel="noreferrer"><RiYoutubeLine /></Link>
                <Link href="https://tiktok.com/@sunulife.sn" target="_blank" rel="noreferrer"><FaTiktok /></Link>
            </div>
            <div><AppDownloadLinks /></div>
            {/* <div className='contenu-date' style={{ maxWidth: `1500px`, textAlign: `justify` }}><Avis /></div> */}
        </div>
    );

    const navbottomEN = (
        <div className="botMenuPadMarg">
            <div className="subNav">
                <Link href='/en/home'>Home</Link>
                <Link href='/en/society'>Society</Link>
                <Link href='/en/chronicles'>Chronicles</Link>
                <Link href='/en/insights'>Insights</Link>
                <Link href='/en/opinions'>Opinions</Link>
                <Link href='/en/destinations'>Destinations</Link>
                <Link href='/en/music'>Music</Link>
                <Link href='/en/moments'>Moments</Link>
                <Link href='/en/videos'>Videos</Link>
                <Link href='/en/tv'>TV</Link>
                <Link href='/en/radio'>Radio</Link>
                <Link href='/en/world-music'>World</Link>
                <Link href='/fr/accueil'>Fran&ccedil;ais</Link>
            </div>
            <br></br>
            <div className="contenu-date">
                <Link href="/en/raqtaq">About</Link>&nbsp;/&nbsp;
                <Link href="/en/icons">Icons</Link>&nbsp;/&nbsp;
                <Link href="/en/advertize">Advertize</Link>&nbsp;/&nbsp;
                <Link href="/en/contact">Contact</Link>&nbsp;/&nbsp;
                <Link href="/en/publish">Publish</Link>&nbsp;/&nbsp;
                <Link href="/en/privacy">Privacy</Link>
                <br></br>
                &copy; {new Date().getFullYear()} <Link href="https://seytoo.io" target='_blank'>, SEYTOO, tous droits r&eacute;serv&eacute;s.</Link>
                <br></br>
                <Link href="https://seytoo.io" target='_blank'><b>Built with love by SEYTOO</b></Link>
            </div>
            <div className="follow" style={{paddingBottom: `20px`}}>
                {/* <Link href="https://t.me/s/raqtaqhub" target="_blank" rel="noreferrer"><FaTelegramPlane /></Link> */}
                <Link href="https://x.com/sunulife_sn" target="_blank" rel="noreferrer"><FaXTwitter /></Link>
                <Link href="https://instagram.com/sunulife.sn" target="_blank" rel="noreferrer"><RiInstagramLine /></Link>
                <Link href="https://facebook.com/sunulife.sn" target="_blank" rel="noreferrer"><RiFacebookFill /></Link>
                <Link href="https://www.youtube.com/@sunulifesn" target="_blank" rel="noreferrer"><RiYoutubeLine /></Link>
                <Link href="https://tiktok.com/@sunulife.sn" target="_blank" rel="noreferrer"><FaTiktok /></Link>
                {/* <Link href="https://www.linkedin.com/company/raqtaq-hub" target="_blank" rel="noreferrer"><FaLinkedinIn /></Link> */}
            </div>
            <div><AppDownloadLinks /></div>
            {/* <div className='contenu-date' style={{ maxWidth: `1500px`, textAlign: `justify` }}><Disclaimer /></div> */}
        </div>
    );

    if (siteVersion === `/en`) {
        return (<div style={{ width: `100%` }}>{navbottomEN}</div>);
    } else {
        return (<div style={{ width: `100%` }}>{navbottomFR}</div>);
    }
}

function NavPlay() {
    const { theaterMode } = useTheaterMode();
    const router = useRouter();
    const activePath = router.asPath;
    const siteVersion = router.pathname.substring(0, 3);

    const isVideoPage =
    router.pathname.startsWith("/en/videos/") ||
    router.pathname.startsWith("/fr/videos/") ||
    router.pathname.startsWith("/fr/tv/") ||
    router.pathname.startsWith("/en/tv/") ||
    router.pathname.startsWith("/en/music/") ||
    router.pathname.startsWith("/fr/music/") ||
        router.pathname.startsWith("/en/world-music/") ||
    router.pathname.startsWith("/fr/world-music/") ||
    router.pathname.startsWith("/en/moments/") ||
    router.pathname.startsWith("/fr/moments/");

    const BackButton = () => {
        const router = useRouter();
        const activePath = router.asPath;
        const goBack = () => {
        router.back();
        };
        if(activePath.startsWith(`/fr`)) {
            return (
            <Link href="javascript:void(0)" onClick={goBack} style={{cursor:`pointer`}}>
                <div className="nav-bot-menu">
                    <div><MdOutlineArrowBackIosNew /></div>
                    <div className='nav-bot-text'>Pr&eacute;c&eacute;d.</div>
                </div>
            </Link>
            );
        } else {
            return (
            <Link href="javascript:void(0)" onClick={goBack} style={{cursor:`pointer`}}>
                <div className="nav-bot-menu">
                    <div><MdOutlineArrowBackIosNew /></div>
                    <div className='nav-bot-text'>Back</div>
                </div>
            </Link>
            );
        }
    };

    const BackButtonSide = () => {
        const router = useRouter();
        const activePath = router.asPath;
        const goBack = () => {
        router.back();
        };
        return (
            <Tippy  className="customTooltip" content={siteVersion === '/fr' ? "Revenir à la page précédente" : "Back to previous page"} placement='left'>
                <Link href="javascript:void(0)" onClick={goBack} style={{cursor:`pointer`}} className={theaterMode ? 'backButtonSide' : 'backButtonSide-light' }>
                    <TiArrowBack size={20} />
                </Link>
            </Tippy>
        );
    };

    const GlobalPlayer = () => {
        if(isVideoPage) {
            return <GlobalVideoPlayer />;
        }

        return <GlobalAudioPlayer />;
    }

    const menuHome = () => {
        if (activePath.startsWith(`/fr/accueil`) || activePath.startsWith(`/en/home`)) {
            return <AiFillHome />;
        } else {
            return <AiOutlineHome />;
        }
    };

    const menuFavorites = () => {
        if (activePath.startsWith(`/fr/fav`) || activePath.startsWith(`/en/fav`)) {
            return <RiHeartsFill />;
        } else {
            return <RiHeartsLine />;
        }
    };

    const menuHistory = () => {
        if (activePath.startsWith(`/fr/monhisto`) || activePath.startsWith(`/en/myhisto`)) {
            return <RiChatHistoryFill />;
        } else {
            return <RiChatHistoryLine />;
        }
    };

    const menuAI = () => {
        if (activePath.startsWith(`/fr/ia`) || activePath.startsWith(`/en/ai`)) {
            return <RiRobot2Fill />;
        } else {
            return <RiRobot2Line />;
        }
    };

    const navPlaFR = (
        <><div className={theaterMode ? 'nav-bot' : 'nav-bot-light'}>
            <Link href="/fr/accueil">
                    <div className="nav-bot-menu">
                        <div>{menuHome()}</div>
                        <div className='nav-bot-text'>Accueil</div>
                    </div>
            </Link>
            <Link href="/fr/ia">
                    <div className="nav-bot-menu">
                        <div>{menuAI()}</div>
                        <div className='nav-bot-text'>IA</div>
                    </div>
            </Link>
            <GlobalPlayer />
            <Link href="/fr/favoris">
                    <div className="nav-bot-menu">
                        <div>{menuFavorites()}</div>
                        <div className='nav-bot-text'>Favori.</div>
                    </div>
            </Link>
            <Link href="/fr/monhistorique">
                    <div className="nav-bot-menu">
                        <div>{menuHistory()}</div>
                        <div className='nav-bot-text'>Histo.</div>
                    </div>
            </Link>
            {/* <BackButton /> */}
        </div>
        <LangButton />
        <BackButtonSide />
        </>
    );

    const navPlaEN = (
        <><div className={theaterMode ? 'nav-bot' : 'nav-bot-light'}>
            <Link href="/en/home">
                <div className="nav-bot-menu">
                    <div>{menuHome()}</div>
                    <div className='nav-bot-text'>Home</div>
                </div>
            </Link>
            <Link href="/en/ai">
                <div className="nav-bot-menu">
                    <div>{menuAI()}</div>
                    <div className='nav-bot-text'>AI</div>
                </div>
            </Link>
            <GlobalPlayer />
            <Link href="/en/favorites">
                <div className="nav-bot-menu">
                    <div>{menuFavorites()}</div>
                    <div className='nav-bot-text'>Favori.</div>
                </div>
            </Link>
            <Link href="/en/myhistory">
                    <div className="nav-bot-menu">
                        <div>{menuHistory()}</div>
                        <div className='nav-bot-text'>Histo.</div>
                    </div>
            </Link>
            {/* <BackButton /> */}
        </div>
        <LangButton />
        <BackButtonSide />
        </>
    );

    if (siteVersion === `/en`) {
        return navPlaEN;
    } else {
        return navPlaFR;
    }
}

function NavSearch() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0,3);

    const navSearchFR =
                        <div className="subNav" style={{padding: `20px`}}>
                            <Link href='/fr/recherche'>Tout</Link>
                            <Link href='/fr/recherche-music'>Music</Link>
                            <Link href='/fr/recherche-videos'>Vid&eacute;os</Link>
                            <Link href='/fr/recherche-tv'>TV</Link>
                            <Link href='/fr/recherche-radio'>Radio</Link>
                        </div>
                    ;
    const navSearchEN =
                        <div className="subNav" style={{padding: `20px`}}>
                            <Link href='/en/search'>All</Link>
                            <Link href='/en/search-music'>Music</Link>
                            <Link href='/en/search-videos'>Videos</Link>
                            <Link href='/en/search-tv'>TV</Link>
                            <Link href='/en/search-radio'>Radio</Link>
                        </div>
                    ;
    if(siteVersion === `/en`) { return navSearchEN } else { return navSearchFR }
}

function NavUser() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0,3);

    const navSearchFR =
                        <div className='menuProfile'>
                            <div className="subNav">
                                <Link href='/my-profile'>Profile</Link>
                                <Link href='/upload-profile-picture'>Picture</Link>
                                {/* <Link href='/'>Favoris</Link> */}
                            </div>
                        </div>
                    ;
    const navSearchEN =
                        <div className='menuProfile'>
                            <div className="subNav">
                                <Link href='/my-profile'>Profile</Link>
                                <Link href='/upload-profile-picture'>Picture</Link>
                                {/* <Link href='/'>Favoris</Link> */}
                                {/* <Link href='/fr/recherche-tv'>TV</Link>
                                <Link href='/fr/recherche-radio'>Radio</Link> */}
                            </div>
                        </div>
                    ;
    if(siteVersion === `/en`) { return navSearchEN } else { return navSearchFR }
}

function NavVideos() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0,3);

    const navVideosFR = () => {
        return (
        <div className="botMenuPadMarg">
            <div className="subNav">
                <Link href='/fr/videos'>Vid&eacute;os</Link>
                <span> &#x25B8; </span>
                <Link href='/fr/videos/original'>Sunulife Originals</Link>
                {/* <Link href='/fr/videos/actualites'>Actualit&eacute;s</Link> */}
                <Link href='/fr/videos/perspective'>Perspective</Link>
                <Link href='/fr/videos/telefilm'>T&eacute;l&eacute;film</Link>
                <Link href='/fr/videos/cinema'>Cin&eacute;ma</Link>
                <Link href='/fr/videos/comedie'>Com&eacute;die</Link>
                <Link href='/fr/videos/cuisine'>Cuisine</Link>
                <Link href='/fr/videos/style'>Style</Link>
                <Link href='/fr/videos/sport'>Sport</Link>
                <Link href='/fr/videos/relax'>Relax</Link>
            </div>
        </div>
        );
    }


    const navVideosEN = () => {
        return (
            <div className="botMenuPadMarg">
                <div className="subNav">
                    <Link href='/en/videos'>Videos</Link>
                    <span> &#x25B8; </span>
                    {/* <Link href='/en/videos/original'>Sunulife Originals</Link> */}
                    {/* <Link href='/en/videos/news'>News</Link> */}
                    <Link href='/en/videos/perspective'>Perspective</Link>
                    <Link href='/en/videos/show'>Show</Link>
                    <Link href='/en/videos/cinema'>Cinema</Link>
                    <Link href='/en/videos/comedy'>Comedy</Link>
                    <Link href='/en/videos/food'>Food</Link>
                    <Link href='/en/videos/style'>Style</Link>
                    <Link href='/en/videos/sport'>Sport</Link>
                    <Link href='/en/videos/relax'>Relax</Link>
                </div>
            </div>
        );
    }

    if(siteVersion === `/en`) { return navVideosEN() } else { return navVideosFR() }
}


function NavFun() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0,3);

    const navFunFR =
                        <div className="subNav" style={{padding: `20px`}}>
                            <Link href='>Music/'>Musique</Link>
                            <Link href='/fr/videos'>Vid&eacute;os</Link>
                            <Link href='/fr/tv'>T&eacute;l&eacute;vision</Link>
                            <Link href='/fr/radio'>Radio</Link>
                        </div>
                    ;
    const navFunEN =
                        <div className="subNav" style={{padding: `20px`}}>
                            <Link href='/en/music/'>Music</Link>
                            <Link href='/en/videos'>Videos</Link>
                            <Link href='/en/tv'>Television</Link>
                            <Link href='/en/radio'>Radio</Link>
                        </div>
                    ;
    if(siteVersion === `/en`) { return navFunEN } else { return navFunFR }
}

function NavFav() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0,3);

    const navFavFR = () => {
        // State to toggle the dropdown visibility
        const [isDropdownOpen, setIsDropdownOpen] = useState(false);

        // Function to handle the dropdown toggle
        const toggleDropdown = () => {
            setIsDropdownOpen(!isDropdownOpen);
        };

        return (
            <div style={{ padding: '20px' }}>
                {/* Main menu item with an onClick event to toggle the dropdown */}
                <div onClick={toggleDropdown} className='catDrop' >
                    Choisir une sous-rubrique <div className="arrow-down"></div>
                </div>
                {/* Dropdown menu items conditionally rendered based on state */}
                {isDropdownOpen && (
                    <div style={{ marginTop: '10px' }} className='catNav'>
                        <Link href='/fr/favreflexion'><p className='catNav'>R&eacute;flexion</p></Link>
                        <Link href='/fr/favstyledevie'><p className='catNav'>Style de vie</p></Link>
                        <Link href='/fr/favfinances'><p className='catNav'>Finances</p></Link>
                        <Link href='/fr/favreussite'><p className='catNav'>R&eacute;ussite</p></Link>
                        <Link href='/fr/favmusic'><p className='catNav'>Music</p></Link>
                        <Link href='/fr/favvideos'><p className='catNav'>Vid&eacute;os</p></Link>
                        <Link href='/fr/favtv'><p className='catNav'>TV</p></Link>
                        <Link href='/fr/favradio'><p className='catNav'>Radio</p></Link>
                    </div>
                )}
            </div>
        );
    }

    const navFavEN = () => {
        // State to toggle the dropdown visibility
        const [isDropdownOpen, setIsDropdownOpen] = useState(false);

        // Function to handle the dropdown toggle
        const toggleDropdown = () => {
            setIsDropdownOpen(!isDropdownOpen);
        };

        return (
            <div style={{ padding: '20px' }}>
                {/* Main menu item with an onClick event to toggle the dropdown */}
                <div onClick={toggleDropdown} className='catDrop' >
                    Choose a sub-category <div className="arrow-down"></div>
                </div>
                {/* Dropdown menu items conditionally rendered based on state */}
                {isDropdownOpen && (
                    <div style={{ marginTop: '10px' }} className='catNav'>
                        <Link href='/en/favreflection'><p className='catNav'>Reflection</p></Link>
                        <Link href='/en/favlife'><p className='catNav'>Life</p></Link>
                        <Link href='/en/favmoney'><p className='catNav'>Money</p></Link>
                        <Link href='/en/favsuccess'><p className='catNav'>Success</p></Link>
                        <Link href='/en/favmusic'><p className='catNav'>Music</p></Link>
                        <Link href='/en/favvideos'><p className='catNav'>Videos</p></Link>
                        <Link href='/en/favtv'><p className='catNav'>TV</p></Link>
                        <Link href='/en/favradio'><p className='catNav'>Radio</p></Link>
                    </div>
                )}
            </div>
        );
    }
    if(siteVersion === `/en`) { return navFavEN() } else { return navFavFR() }
}

function NavHistory() {
    const router = useRouter();
    const siteVersion = router.pathname.substring(0,3);

    const navFavFR =
                        <div className="subNav" style={{padding: `20px`}}>
                            <Link href='/fr/historique'>Historique</Link>
                            <span> &#x25B8; </span>
                            <Link href='/fr/histomusic'>Music</Link>
                            <Link href='/fr/histotv'>TV</Link>
                            <Link href='/fr/historadio'>Radio</Link>
                            <Link href='/fr/histovideos'>Vid&eacute;os</Link>
                            {/* <Link href='/fr/favarticles'>Articles</Link> */}
                            {/* <Link href='/fr/historique'>R&eacute;cents</Link> */}
                        </div>
                    ;
    const navFavEN =
                        <div className="subNav" style={{padding: `20px`}}>
                            <Link href='/en/history'>History</Link>
                            <span> &#x25B8; </span>
                            <Link href='/en/histomusic'>Music</Link>
                            <Link href='/en/histotv'>TV</Link>
                            <Link href='/en/historadio'>Radio</Link>
                            <Link href='/en/histovideos'>Videos</Link>
                            {/* <Link href='/favarticles'>Articles</Link> */}
                            {/* <Link href='/en/history'>Recent</Link> */}
                        </div>
                    ;
    if(siteVersion === `/en`) { return navFavEN } else { return navFaFR }
}

export {
    NavTop,
    NavBottom,
    NavPlay,
    NavSearch,
    NavVideos,
    NavFav,
    NavHistory,
    NavFun,
    LangButton,
    NavUser
}